module.exports = __webpack_public_path__ + "d51367d18f4a2cd00bf753183871116f.png";